// extracted by mini-css-extract-plugin
export default {"ShareButton":"Buttons_ShareButton__pTQ05","LikeButton":"Buttons_LikeButton__Y9URR"};